//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BookingTerminalCard from './terminal-card.vue';

export default {
  name: 'booking-preparation-steps',
  components: { BookingTerminalCard },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    detailed: {
      type: Boolean,
      default: false,
    },
  },
};
